// Kept in its own module so screens can show it without importing the Supabase client.
export function cloudSetupMessage() {
  return 'Cloud accounts and shared records are not connected yet. Add the Resident Service 360 Supabase URL and publishable key to this environment to enable this workflow.';
}
